import table_messages from 'messages/table_messages';
import { StaticTableFilter } from 'types/TableFilter';

import booleanDictionary from '../../booleanDictionary';

const incompleteAssetsFilter: StaticTableFilter = {
  isDynamic: false,
  sectionName: table_messages.assets_filters.incomplete_assets,
  filters: booleanDictionary,
  isSingleSelect: true,
};

export default incompleteAssetsFilter;
